import { cardsData } from '@/mocks/homeData';

export default function SectionCards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">精选推荐</h2>
          <p className="text-sm text-foreground-500 mt-2">编辑团队精心筛选的高分热门电视剧</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {cardsData.map((card, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[3/4] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={idx > 2 ? 'lazy' : undefined}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute top-2.5 left-2.5">
                  <span className="px-2 py-0.5 bg-accent-500 text-white text-[11px] font-medium rounded-full">
                    {card.rating}
                  </span>
                </div>
                <div className="absolute bottom-3 left-3 right-3">
                  <div className="text-white text-xs font-medium">{card.title}</div>
                </div>
              </div>
              <div className="p-3">
                <div className="text-[11px] text-foreground-400 mb-1">{card.category}</div>
                <p className="text-xs text-foreground-600 leading-snug line-clamp-2">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}